export const GET_PAYMENT_GATEWAYS = "GET_PAYMENT_GATEWAYS";
export const GET_STRIPE_PUBLIC_KEY = "GET_STRIPE_PUBLIC_KEY";
